<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {},
  methods: {}
}
</script>
<style lang="less" scoped>
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
::-webkit-scrollbar {
  display: none;
}
</style>
